/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ArchivedIssuesEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const archivedIssuesEntrypoint: EntryPoint<ArchivedIssuesEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ArchivedIssuesEntrypointComponent>(
			/* webpackChunkName: "async-archived-issues-entrypoint" */ './JiraIssuesArchiveMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
